import {html, css, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {FeatureSelectItem} from './featureSelectItem';
import radio from '../../../icons/radio';
import custom from '../../../icons/custom';
import StandardColourOfChoice from '../../../icons/StandardColourOfChoice';
import {pimText} from '../../util/values';

@customElement('feature-color-select-item')
export class FeatureColorSelectItem extends FeatureSelectItem {

	static styles = [
		css`
			:host {
			}

			.item {
				position: relative;
			}

			.item button {
				display: flex;
				align-items: center;
				justify-content: center;

				width: 100%;
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				background-color: transparent;
				height: var(--height-widget);
				min-width: var(--height-widget);
				cursor: pointer;
				white-space: nowrap;
				transition: background-color 0.4s, color 0.4s;
				padding: 0;
				text-align: center;
				border: 0 none;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}

			button:hover {
				background-color: var(--color-widget-background-hover);
			}

			button svg {
				fill: currentColor;
			}

			.selected button {
				background-color: var(--color-widget-background-selected);
			}

			.fixed button {
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-widget-border);
			}

			.disabled button:hover {
				color: var(--color-widget-border);
			}

			.disabled button svg {
				opacity: 0.3;
			}

			.hoverinfo {
				transition: left 0.25s ease-out, opacity 0.25s ease-out;
				transform: translateY(-50%);
				display: block;
				opacity: 0;
				pointer-events: none;
				position: absolute;
				top: 18px;
				left: calc(100% + 25px);
				z-index: 10;
				margin: 0 auto;
				width: 200px;
			}

			.item:hover .hoverinfo {
				display: block;
				opacity: 1;
				left: calc(100% + 5px);
				transition-delay: 0.2s;
			}

			.hoverinfo .content {
				position: relative;
				border: var(--border-widget);
				padding: 0.5em 1em;
				background-color: var(--color-black);
				font-family: var(--font-family-light);
				color: var(--color-widget-text);
				font-size: var(--font-size-widget);
			}

			.hoverinfo .content:after {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				width: 0;
				height: 0;
				border: 10px solid transparent;
				border-right-color: #000000;
				border-left: 0;
				margin-top: -10px;
				margin-left: -10px;
			}

			.hoverinfo .content:before {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				width: 0;
				height: 0;
				border: 12px solid transparent;
				border-right-color: var(--border-widget);
				border-left: 0;
				margin-top: -12px;
				margin-left: -12px;
			}
		`];

	getInfoText() {
		const display = pimText(this.lang, this.feature.variableId, 'FV', this.decisions, this.translations, this.featureValue.featureValueId);
		return display + (super.getInfoText() !== '' ? ', ' + super.getInfoText() : '');
	}
	render() {
		const hexColor = this.productData?.displayColour ?? '#0F0';
		let icon = radio;
		switch (this.productData?.displayColour) {
			case 'custom':
				icon = custom;
				break;
			case 'StandardColourOfChoice':
				icon = StandardColourOfChoice;
				break;
		}
		return html`
			<div class="item ${classMap({selected: this.isIncluded(), disabled: !this.canBeIncluded(), fixed: !this.canBeExcluded()})}">
				<button @click="${this.toggleDecision}" style="color: ${unsafeCSS(hexColor)}">
					${icon}
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.getInfoText()}
						</div>
					</div>
				`)}
			</div>
		`;
	}
}
